/* Superoom - sticky add to cart. Styling lives in superoom-faq-compact.css (.sr-satc).

   IT RUNS ON DESKTOP TOO. It began mobile-only, hidden above 768px by a display:none in the CSS.
   On a page this long the buy box is off screen for most of the scroll at every width, so the
   desktop reader had no way to buy without scrolling back up. The bar is now shown at all widths
   and laid out differently above 768px; the CSS owns that, and this file is width-agnostic.

   TWO MODES, and the order matters.

   MODULE MODE is the one that runs on the new PDP. The First Drop Kit module owns the purchase:
   which variant, which selling plan, and the line item properties that mark the kit. So the bar
   must not build its own add-to-cart. It watches the module's CTA for position, mirrors the price
   the module is currently showing, and on tap clicks that CTA, so the subscription comes with it
   and the add-to-cart logic stays in one place.

   The module is an OPTION LIST, not a two-tab toggle, so the selected option is read from
   [data-sro-opt][aria-checked="true"]. The old [data-sro-tab="monthly"] lookup fell back to true
   when the element was missing, which meant the bar said ADD MY KIT even when a one-off was
   selected. Four options now, and only the two subscriptions carry the kit.

   LEGACY MODE is the original behaviour against the theme's main-product form, kept because the
   other product templates still use it. An older version of this file ONLY had legacy mode, which
   is why the bar was dead on the new PDP: the module hides the main-product section, so the old
   CTA's bounding rect collapsed to zero, r.bottom < 0 was never true, and the bar never showed.

   THE BAR STANDS DOWN over the footer and over the closing FAQ card, because that card carries its
   own subscribe button and two buy buttons in one viewport is one too many. If it ever looks like
   the bar has stopped following you, check whether one of those is on screen before assuming it
   has broken - and note that Shopify's own theme-preview bar sits at the bottom of the window on a
   preview URL and will cover this bar completely. That is a preview artefact, not a bug. */
(function () {
  var BAR = null;

  function productName() {
    var el = document.querySelector('[data-sro-root] h1') || document.querySelector('h1');
    return el ? (el.textContent || '').trim() : '';
  }

  function build() {
    var bar = document.createElement('div');
    bar.className = 'sr-satc';
    var img = document.createElement('img');
    img.className = 'sr-satc__img';
    img.alt = '';
    /* Shown only above 768px. On a phone there is no room for it and the page you are on is
       obvious; on a wide screen a bar with no product name reads as an orphaned control. */
    var name = document.createElement('span');
    name.className = 'sr-satc__name';
    name.textContent = productName();
    var meta = document.createElement('span');
    meta.className = 'sr-satc__meta';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sr-satc__btn';
    btn.textContent = 'ADD TO CART';
    bar.appendChild(img);
    bar.appendChild(name);
    bar.appendChild(meta);
    bar.appendChild(btn);
    document.body.appendChild(bar);
    return { bar: bar, img: img, name: name, meta: meta, btn: btn };
  }

  function drawerOpen() {
    var d = document.getElementById('cart-drawer');
    if (!d) return false;
    try { return window.getComputedStyle(d).display !== 'none'; } catch (e) { return false; }
  }

  function onScreen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    return r.top < window.innerHeight && r.bottom > 0;
  }

  /* ---------------- module mode ---------------- */

  function initModule(cta) {
    var ui = build();
    var footer = document.querySelector('.shopify-section--footer');
    var closing = document.querySelector('[data-fc-cta]');
    var lastLabel = null, lastMeta = null, lastImg = null;

    // Which of the four options is selected. Defaults to the subscription, which is the option
    // the module itself renders checked.
    function chosen() {
      var el = document.querySelector('[data-sro-opt][aria-checked="true"]');
      return el ? el.getAttribute('data-sro-opt') : 'sub';
    }

    function price() {
      var p = document.querySelector('[data-sro-price]');
      var txt = p ? (p.textContent || '').trim() : '';
      return txt || null;
    }

    function sync() {
      var opt = chosen();
      var isKit = (opt === 'sub' || opt === 'pair');
      var p = price();
      var label = (isKit ? 'ADD MY KIT' : 'ADD') + (p ? ' · ' + p : '');
      if (label !== lastLabel) { lastLabel = label; ui.btn.textContent = label; }

      if (!ui.name.textContent) ui.name.textContent = productName();

      // Meta line: the kit tiers say so, the one-offs name the size being bought.
      var m = '';
      if (isKit) m = 'Kit included';
      else if (opt === '50ml') m = '50ml, one time';
      else if (opt === '15ml') m = '15ml mini, one time';
      if (m !== lastMeta) { lastMeta = m; ui.meta.textContent = m; }

      /* Thumbnail is the hero shot. It used to follow the mini chip the shopper picked, but the
         free mini is chosen in the cart drawer now and the chip row is hidden, so there is no
         selection here to follow. */
      var src = null;
      var hero = document.querySelector('[data-sro-hero]');
      if (hero) src = hero.currentSrc || hero.src;
      if (src && src !== lastImg) { lastImg = src; ui.img.src = src; ui.img.style.display = 'block'; }
      if (!src) ui.img.style.display = 'none';
    }

    function update() {
      sync();
      var r = cta.getBoundingClientRect();
      var past = r.bottom < 0;
      var blocked = onScreen(footer) || onScreen(closing) || drawerOpen();
      if (past && !blocked) ui.bar.classList.add('is-on');
      else ui.bar.classList.remove('is-on');
    }

    ui.btn.addEventListener('click', function () {
      cta.click();
      window.setTimeout(update, 200);
    });

    var last = 0;
    function onScroll() { if (Date.now() - last > 80) { last = Date.now(); update(); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('click', function () { window.setTimeout(update, 150); });
    window.setInterval(update, 500);
    update();
    return true;
  }

  /* ---------------- legacy mode ---------------- */

  function variantMap() {
    var el = document.getElementById('sr-satc-data');
    if (!el) return {};
    try {
      var d = JSON.parse(el.textContent), m = {};
      (d.variants || []).forEach(function (v) { m[String(v.id)] = v; });
      return m;
    } catch (e) { return {}; }
  }

  // Read the price of the CHECKED purchase option. The Seal widget puts several money values in
  // one block: "SAVE £5.00", the struck-through compare-at, the real price, and a per-serving
  // figure. Strip the save amount and the per-serving figure, then take the last value left.
  function selectedPrice() {
    var radios = document.querySelectorAll('input[type="radio"][name^="subs_type"]');
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var box = radios[i].closest('.sls-option-container') || radios[i].parentElement;
      if (!box) continue;
      var txt = (box.innerText || '')
        .replace(/[£$€][\d.,]+\s*(?:\/|per)\s*serving/gi, '')
        .replace(/save\s*[£$€][\d.,]+/gi, '');
      var found = txt.match(/[£$€][\d.,]+/g);
      if (found && found.length) return found[found.length - 1];
    }
    return null;
  }

  function initLegacy() {
    if (!document.querySelector('.shopify-section--main-product')) return false;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return false;
    var atc = form.querySelector('[type="submit"]');
    if (!atc) return false;

    var ui = build();
    var map = variantMap();
    var footer = document.querySelector('.shopify-section--footer');
    var lastId = null, lastPrice = null;

    ui.btn.addEventListener('click', function () { atc.click(); });

    function syncVariant() {
      var input = form.querySelector('input[name="id"]');
      var id = input ? String(input.value) : null;
      if (id && id !== lastId) {
        lastId = id;
        var v = map[id];
        if (v) {
          if (v.img) { ui.img.src = v.img; ui.img.style.display = 'block'; }
          else { ui.img.style.display = 'none'; }
          ui.meta.textContent = (v.title && v.title !== 'Default Title') ? v.title : '';
        }
      }
      var p = selectedPrice();
      if (p !== lastPrice) {
        lastPrice = p;
        ui.btn.textContent = p ? ('ADD TO CART · ' + p) : 'ADD TO CART';
      }
    }

    function update() {
      syncVariant();
      var r = atc.getBoundingClientRect();
      var past = r.bottom < 0;
      if (past && !onScreen(footer) && !drawerOpen()) ui.bar.classList.add('is-on');
      else ui.bar.classList.remove('is-on');
    }

    var last = 0;
    function onScroll() { if (Date.now() - last > 80) { last = Date.now(); update(); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    form.addEventListener('change', syncVariant);
    document.addEventListener('click', function () { window.setTimeout(update, 150); });
    window.setInterval(update, 500);
    update();
    return true;
  }

  function init() {
    if (BAR) return;
    if (document.querySelector('.sr-satc')) { BAR = true; return; }
    var cta = document.querySelector('[data-sro-cta]');
    if (cta) { BAR = initModule(cta); return; }
    BAR = initLegacy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The module renders from Liquid but its JS boots on DOMContentLoaded; retry once for the case
  // where this file wins the race, and again for section reloads in the theme editor.
  window.setTimeout(init, 1200);
  document.addEventListener('shopify:section:load', function () { window.setTimeout(init, 120); });
})();
